import { useEffect, useState } from 'react';
import { Consulta } from '../services/mockData';
import { useAuth } from '../contexts/AuthContext';
import { getConsultasProximosDias } from '../services/dataService';

export function useConsultas(diasJanela: number = 7) {
  const { user } = useAuth();
  const [data, setData] = useState<Consulta[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadConsultas = async () => {
    if (!user) {
      setData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const consultas = await getConsultasProximosDias(
        user.uid,
        diasJanela
      );
      setData(consultas);
    } catch {
      setError('Não foi possível carregar as consultas.');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    async function load() {
      if (!user) {
        if (isMounted) {
          setData([]);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const consultas = await getConsultasProximosDias(
          user.uid,
          diasJanela
        );
        if (isMounted) {
          setData(consultas);
        }
      } catch {
        if (isMounted) {
          setError('Não foi possível carregar as consultas.');
          setData([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, [user, diasJanela]);

  return { consultas: data, loading, error, refresh: loadConsultas };
}

